import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "75.999",
  height: "24.573",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m70.369 24.22-.713-3.563h-7.96l-1.268 3.537-6.38.012q4.556-10.957 9.132-21.907c.52-1.238 1.441-1.868 2.8-1.862q1.557.014 5.085.004l4.934 23.77zm-6.882-8.443h5.13l-1.915-8.93ZM22.357.434l6.415.007-9.918 23.781-6.494-.006a3013 3013 0 0 1-4.84-18.86c-.316-1.255-.943-2.132-2.15-2.547Q3.761 2.257 0 1.093v-.65h10.25c1.773 0 2.81.86 3.141 2.62q.502 2.645 2.533 13.47zm15.231.007-5.073 23.775-6.105-.007L31.477.434ZM49.97.001c1.827 0 4.13.57 5.453 1.092l-1.07 4.93c-1.197-.48-3.167-1.13-4.823-1.108-2.407.041-3.895 1.051-3.895 2.02 0 1.577 2.584 2.372 5.244 4.095 3.037 1.963 3.436 3.727 3.398 5.643-.04 3.977-3.398 7.9-10.479 7.9-3.23-.047-4.395-.32-7.03-1.253l1.115-5.146c2.682 1.124 3.82 1.482 6.111 1.482 2.1 0 3.902-.849 3.918-2.328.012-1.05-.634-1.573-2.99-2.872-2.356-1.3-5.662-3.103-5.617-6.72C39.358 3.106 43.745 0 49.973 0Z",
      style: {"fill":"currentColor","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }